/**
 * Checks if a given path should be treated as external media (starts with `/media`).
 * Usage:
 * ```ts
 * <script setup lang="ts">
 * const { checkExternal } = usePathGuard();
 * const somePath = "/media/uploads/image.jpg";
 * </script>
 *
 * <template>
 *   <nuxt-link :to="somePath" :external="checkExternal(somePath)">
 *     View Media
 *   </nuxt-link>
 * </template>
 * ```
 */

export const usePathGuard = () => {
  const checkExternal = (path?: string): boolean => {
    if (!path) return false;
    if (path.startsWith('http')) return false;
    // Check if it’s a relative media path
    return /^\/media(?:\/|$)/.test(path);
  };

  return { checkExternal };
};
